import { LayersControl } from 'react-leaflet'

import { GoogleMutantLayer } from '../google-mutant-layer'

type GoogleMutantType = 'roadmap' | 'satellite' | 'terrain' | 'hybrid'
type Options = {
  name: string
  type: GoogleMutantType
  default?: boolean
}[]

const options: Options = [
  {
    name: 'Satélite',
    type: 'satellite',
    default: true,
  },
  {
    name: 'Mapa',
    type: 'roadmap',
  },
  {
    name: 'Híbrido',
    type: 'hybrid',
  },
]

interface BaseLayerControlProps {
  disabledControls?: boolean
  opacity?: number
}

export const BaseLayerControl = ({
  disabledControls = false,
  opacity,
}: BaseLayerControlProps) => {
  return disabledControls ? (
    <GoogleMutantLayer type='satellite' opacity={opacity} />
  ) : (
    <LayersControl autoZIndex={false}>
      {options.map((option) => (
        <LayersControl.BaseLayer
          key={option.type}
          name={option.name}
          checked={option.default}
        >
          <GoogleMutantLayer type={option.type} opacity={opacity} />
        </LayersControl.BaseLayer>
      ))}
    </LayersControl>
  )
}
